import { ca } from '@cian/analytics';

export function trackButtonClick() {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Open',
    label: 'From_cat_save_fastfilters',
  });
}
